import { nest } from 'recompose';
import ScrollElement from './ScrollElement';

const withScroll = (component) => nest(ScrollElement, component);

export default withScroll;
